'use strict';

const VueRenderer = require('client/src/renderers/vue-renderer');
const EntityFormViewComponent = require('../views/entity-form-view/EntityFormView.vue').default;
const IAPI = require('core/src/api-client-abstract').default;
const _ = require('core/src/utils/legacy');

const NodeFormViewVueRenderer = function (dependencies) {
	console.error('NodeFormViewVueRenderer !!!');
	VueRenderer.call(this, dependencies);
	this.api = dependencies.get(IAPI);


};
NodeFormViewVueRenderer.viewType = 'NodeFormVueView'; // This should match the function name
NodeFormViewVueRenderer.prototype = Object.create(VueRenderer.prototype);

NodeFormViewVueRenderer.prototype.getVueComponent = function () {
	return EntityFormViewComponent;
};

// NodeFormViewVueRenderer.prototype.initVueComponent = function(component) {
// 	// The `doRender` method from the original renderer receives `renderData`.
// 	// We pass this data to the Vue component's props.
// 	this.setComponentProps({
// 		node: this.renderData.node || {}
// 	});

// 	component.$on('save', (nodeData) => {
// 		this.requestSaveEntity(nodeData);
// 	});

// 	component.$on('cancel', () => {
// 		// Assuming there is a method to close the view/dialog
// 		if (typeof this.close === 'function') {
// 			this.close();
// 		}
// 	});
// };


module.exports = NodeFormViewVueRenderer;
